export default "__VITE_ASSET__BUbstcUm__"